import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getNews } from "../services/newsService";
import DOMPurify from "dompurify";
import SideBarCategories from "./SideBarCategories";
import SideBarPolls from "../components/SideBarPolls";

const GetNewsList = ({ initialNews, totalRecords }) => {
  const [news, setNews] = useState(initialNews);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 8;
  const [categoryId, setCategoryId] = useState(null);
  const { category, query } = useParams();
  const searchTerm = query ? query.replace(/-/g, " ") : ""; // Convert back to spaces
  const navigate = useNavigate();

  useEffect(() => {
    setCurrentPage(1);
    setNews(initialNews);
  }, [initialNews]);

  const loadMoreNews = async () => {
    setLoading(true);
    try {
      const requestData = {
        PageNumber: currentPage + 1,
        PageSize: pageSize,
        Slug: category,
        Filtertext: searchTerm,
      };

      const response = await getNews(requestData);
      if (response.success) {
        setNews([...news, ...response.newsPagedResult.data]);
        setCurrentPage(currentPage + 1);
      }
    } catch (error) {
      console.error("Error fetching more news:", error);
    }
    setLoading(false);
  };

  return (
    <div className="post-list single-post">
      <div className="container-fluid px-0">
      <div className="px-0 px-sm-3 px-md-4 px-lg-5">
        <div className="row">
          
          {/* News List Section */}
          <div className="col-lg-8 col-12">
              <div className="px-0">
              {news.length > 0 ? (
                news.map((item, index) => (
                  <div
                    className="row align-items-center mb-4 p-3 border-bottom"
                    key={index}
                  >
                    {/* Responsive Image */}
                    <div className="col-md-4 col-12 mb-3 mb-md-0">
                    <div className="news-image-wrapper">
                        <img
                          src={item.imagePath}
                          alt={item.imageAltText}
                          onClick={() => navigate(`/${item.language}/${item.category}/${item.slug}`)}
                        />
                  </div>

                    </div>

                    {/* Text Content */}
                    <div className="col-md-8 col-12">
                      <h5
                        className="fw-bold mb-2 text-dark post-lineht"
                        onClick={() =>
                          navigate(`/${item.language}/${item.category}/${item.slug}`)
                        }
                        style={{ cursor: "pointer" }}
                      >
                        {item.title}
                      </h5>
                      <p
                        className="text-muted mb-0 small post-lineht"
                        onClick={() =>
                          navigate(`/${item.language}/${item.category}/${item.slug}`)
                        }
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(
                            item.subTitle.slice(0, 120) + "..."
                          ),
                        }}
                        style={{ cursor: "pointer" }}
                      ></p>
                    </div>
                  </div>
                ))
              ) : (
                <p className="text-center text-muted">No News Found</p>
              )}
            </div>

            {/* Load More Button */}
            {news.length < totalRecords && (
              <div className="text-center mt-4">
                <button
                  className="btn btn-dark px-5 py-2 w-100 w-md-auto shadow-sm"
                  onClick={loadMoreNews}
                  disabled={loading}
                >
                  {loading ? "Loading..." : "Load More"}
                </button>
              </div>
            )}
          </div>

          {/* Sidebar Section */}
          <div className="col-lg-4 col-12 mt-4 mt-lg-0">
            <div className="sidebar">
              <SideBarPolls />
              <SideBarCategories />
            </div>
          </div>

        </div>
        </div>
      </div>
    </div>
  );
};

export default GetNewsList;